module.exports = __webpack_public_path__ + "img/news_img1.296de343.png";